import { IFirmwareTypes } from 'types';

export const firmwareTypes: IFirmwareTypes[] = [
	{ firmwareTypeID: 1, firmwareTypeName: 'Android' },
	{ firmwareTypeID: 2, firmwareTypeName: 'MAX' },
];
